import { ThemeDefinition } from 'src/game/theme/Theme';
import {
  StreakBattleRoyaleMapConfig,
  StreakBattleRoyaleThemeAssetKey,
  StreakBattleRoyaleThemeAssets,
  StreakBattleRoyaleThemeProvider,
  StreakBattleRoyaleThemeStyleKey,
  StreakBattleRoyaleThemeStyles,
} from '../streakbattleroyale.theme';

const assets: Partial<StreakBattleRoyaleThemeAssets> = {
  panel_info: 'assets/ui/match2/streakbattleroyaleV2/fujiquest-panel.png',
  panel_prize: 'assets/ui/match2/streakbattleroyaleV2/intro/bubble.png',
  cloud_1: 'assets/ui/match2/streakbattleroyale/streakbattleroyale_cloud_1.png',
  cloud_2: 'assets/ui/match2/streakbattleroyale/streakbattleroyale_cloud_2.png',
  cloud_3: 'assets/ui/match2/streakbattleroyale/streakbattleroyale_cloud_3.png',
  gem_banner: 'assets/ui/match2/streakbattleroyaleV2/reward/graphic-ribbon.png',
  glare: 'assets/ui/match2/streakbattleroyale/streakbattleroyale_glare.png',
  ground: 'assets/ui/match2/streakbattleroyaleV2/fujiquest-shrine.png',
  hero: 'assets/ui/match2/streakbattleroyaleV2/intro/bg.png',
  message_bg:
    'assets/ui/match2/streakbattleroyale/streakbattleroyale_message_bg.png',
  retry_flag: 'assets/ui/match2/streakbattleroyaleV2/retry/retry-flag.png',
  retry_flag2: 'assets/ui/match2/streakbattleroyaleV2/retry/retry-flag2.png',
  spinner: 'assets/ui/match2/streakbattleroyale/streakbattleroyale_spinner.png',
  trophy: 'assets/ui/match2/streakbattleroyaleV2/reward/graphic-gems.png',
  you_made_it_en:
    'assets/ui/match2/streakbattleroyale/streakbattleroyale_you_made_it_en.png',
  you_made_it_ja:
    'assets/ui/match2/streakbattleroyale/streakbattleroyale_you_made_it_ja.png',
  title_congratulations_en:
    'assets/ui/match2/streakbattleroyaleV2/reward/title-congratulations-en.png',
  title_congratulations_ja:
    'assets/ui/match2/streakbattleroyaleV2/reward/title-congratulations-ja.png',
  title_event_en:
    'assets/ui/match2/streakbattleroyale/title_streakbattleroyale_event_en.png',
  title_event_ja:
    'assets/ui/match2/streakbattleroyale/title_streakbattleroyale_event_ja.png',

  intro_cloud: 'assets/ui/match2/streakbattleroyaleV2/intro/cloud.png',
  intro_mascot1: 'assets/ui/match2/streakbattleroyaleV2/intro/momonga.png',
  intro_mascot2: 'assets/ui/match2/streakbattleroyaleV2/intro/mouse.png',
  intro_mascot3: 'assets/ui/match2/streakbattleroyaleV2/intro/alpaca.png',
  matchmaking_bg: 'assets/ui/match2/streakbattleroyaleV2/matching/bg.png',
  chest: 'assets/ui/match2/streakbattleroyaleV2/chest.png',
  platform: 'assets/ui/match2/streakbattleroyaleV2/matching/platform.png',
  home_label: 'assets/ui/match2/streakbattleroyaleV2/button/label-bg.png',
  subpanel_info: 'assets/ui/match2/streakbattleroyaleV2/fujiquest-subpanel.png',
  icon_death: 'assets/ui/match2/streakbattleroyaleV2/fujiquest-icon-death.png',
  frame_death:
    'assets/ui/match2/streakbattleroyaleV2/fujiquest-frame-death.png',
};

const styles: StreakBattleRoyaleThemeStyles = {
  introPrize: {
    y: 170,
  },
  matchmakingHeader: {
    width: 720,
    height: 544,
  },
};

const spineHeight = 542;
const refSize = 909;
const scaleFactor = (refSize / spineHeight) * 1.22;

const mapConfig: StreakBattleRoyaleMapConfig = {
  background: 'assets/ui/match2/streakbattleroyaleV2/fujiquest-background.png',
  checkpoints: [
    { x: 189, y: 1086 },
    { x: 336, y: 985 },
    { x: 441, y: 881 },
    { x: 298, y: 810 },
    { x: 213, y: 714 },
    { x: 311, y: 625 },
    { x: 441, y: 565 },
  ],
  checkPointScales: [
    (276 * scaleFactor) / refSize,
    (235 * scaleFactor) / refSize,
    (223 * scaleFactor) / refSize,
    (208 * scaleFactor) / refSize,
    (182 * scaleFactor) / refSize,
    (165 * scaleFactor) / refSize,
    (146 * scaleFactor) / refSize,
  ],
};

export const streakBattleRoyaleThemeV2: ThemeDefinition<StreakBattleRoyaleThemeProvider> =
  {
    getMapConfig: () => mapConfig,
    getStyle: (key: StreakBattleRoyaleThemeStyleKey) => styles[key],
    getAsset: (key: StreakBattleRoyaleThemeAssetKey) => assets[key],
    getAssets: () => [...Object.values(assets), mapConfig.background!],
  };
